/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************!*\
  !*** ./js/cart-checkbox.js ***!
  \*****************************/
var changeDisabled = function changeDisabled(checked) {
  var ctas = document.getElementById('cart__ctas');
  var dynamic = document.getElementById('cart__dynamic-checkout-buttons');

  if (checked) {
    if (ctas) ctas.classList.remove('disabled');
    if (dynamic) dynamic.classList.remove('disabled');
  } else {
    if (ctas) ctas.classList.add('disabled');
    if (dynamic) dynamic.classList.add('disabled');
  }
};

window.onload = function () {
  changeDisabled(false);
  var checkbox = document.getElementById('cart__checkbox');
  checkbox.addEventListener('change', function (e) {
    changeDisabled(e.target.checked);
  });
};
/******/ })()
;